import { listDocs, getDoc, createDoc, updateDoc, deleteDoc } from './appDataClient';
import { pollingSubscription } from './adapters';
import { getDashboard, getDashboardCharts, fetchChartData } from './dashboard';

// Data screens are stored through /api/app-data.

const SCREENS = 'dataScreens';

export const createDataScreen = async (screenData) => createDoc(SCREENS, screenData);

export const getDataScreen = async (screenId) => getDoc(SCREENS, screenId);

export const getAccountDataScreens = async (accountId) =>
  listDocs(SCREENS, { accountId });

export const getAllDataScreens = async () => listDocs(SCREENS);

export const updateDataScreen = async (screenId, updates) =>
  updateDoc(SCREENS, screenId, updates);

export const deleteDataScreen = async (screenId) => deleteDoc(SCREENS, screenId);

export const loadScreenData = async (screen) => {
  try {
    const data = {};

    for (const item of screen.layout) {
      if (item.type === 'dashboard' && item.dashboardId) {
        const dashboard = await getDashboard(item.dashboardId);
        const charts = await getDashboardCharts(item.dashboardId);

        const chartsData = {};
        for (const chart of charts) {
          const chartData = await fetchChartData(chart);
          chartsData[chart.id] = chartData;
        }

        data[item.dashboardId] = {
          dashboard,
          charts,
          chartsData
        };
      } else if (item.type === 'chart' && item.chartId) {
        // Load single chart data if needed
        // This would require storing chart configs separately
      }
    }

    return data;
  } catch (error) {
    console.error('Error loading screen data:', error);
    throw error;
  }
};

// ===== Real-time Subscriptions =====

export const subscribeToDataScreens = (accountId, callback) =>
  pollingSubscription(() => getAccountDataScreens(accountId), callback);

export const subscribeToDataScreen = (screenId, callback) =>
  pollingSubscription(() => getDataScreen(screenId), callback);

export const getDefaultThemes = () => {
  return [
    {
      name: '暗夜藍',
      backgroundColor: '#0f172a',
      textColor: '#ffffff',
      accentColor: '#667eea'
    },
    {
      name: '深邃黑',
      backgroundColor: '#1a1a1a',
      textColor: '#f0f0f0',
      accentColor: '#00d4ff'
    },
    {
      name: '科技綠',
      backgroundColor: '#0d1b2a',
      textColor: '#e0f2fe',
      accentColor: '#00ff88'
    },
    {
      name: '商務灰',
      backgroundColor: '#2d3748',
      textColor: '#ffffff',
      accentColor: '#fbbf24'
    },
    {
      name: '純淨白',
      backgroundColor: '#ffffff',
      textColor: '#1a202c',
      accentColor: '#667eea'
    }
  ];
};

export const generateLayoutGrid = (rows = 3, cols = 3) => {
  const grid = [];
  const cellWidth = 100 / cols;
  const cellHeight = 100 / rows;

  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      grid.push({
        x: j * cellWidth,
        y: i * cellHeight,
        width: cellWidth,
        height: cellHeight
      });
    }
  }

  return grid;
};

export const duplicateDataScreen = async (screenId, accountId) => {
  try {
    const screen = await getDataScreen(screenId);

    const newScreen = await createDataScreen({
      ...screen,
      name: `${screen.name} (複製)`,
      accountId
    });

    return newScreen;
  } catch (error) {
    console.error('Error duplicating data screen:', error);
    throw error;
  }
};

export const exportScreenConfig = (screen) => {
  const config = {
    name: screen.name,
    description: screen.description,
    layout: screen.layout,
    theme: screen.theme,
    autoRotate: screen.autoRotate,
    rotateInterval: screen.rotateInterval,
    refreshInterval: screen.refreshInterval
  };

  const blob = new Blob([JSON.stringify(config, null, 2)], {
    type: 'application/json'
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `data_screen_${screen.name}_${Date.now()}.json`;
  link.click();
  URL.revokeObjectURL(url);
};

export const getGridPositions = () => {
  return [
    { label: '全螢幕', x: 0, y: 0, width: 100, height: 100 },
    { label: '左半屏', x: 0, y: 0, width: 50, height: 100 },
    { label: '右半屏', x: 50, y: 0, width: 50, height: 100 },
    { label: '上半屏', x: 0, y: 0, width: 100, height: 50 },
    { label: '下半屏', x: 0, y: 50, width: 100, height: 50 },
    { label: '左上', x: 0, y: 0, width: 50, height: 50 },
    { label: '右上', x: 50, y: 0, width: 50, height: 50 },
    { label: '左下', x: 0, y: 50, width: 50, height: 50 },
    { label: '右下', x: 50, y: 50, width: 50, height: 50 }
  ];
};
